import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useTranslation } from 'react-i18next';

// -- Component 

import Box from '@mui/material/Box';
import GroupAccessList from './groupAccess/list/GroupAccessList';
import CreateGroupAccess from './groupAccess/create/CreateGroupAccess';
import Invite from './groupAccess/popups/Invite';
import Paywall from './paywall/Paywall';
import Billing from './billing/Billing';
import Interface from '../general/containers/Interface';

const Container: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const navigate = useNavigate();
    const { t } = useTranslation();

    const colors = useAppSelector(state => state.theme.colors);
    const section = useAppSelector(state => state.navigation.section);

    return (

        <Interface>

            {section === 'groupAccessList' && <GroupAccessList />}
            {section === 'billing' && <Billing />}
            {section === 'plans' && <Paywall />}
            {section === 'createGroupAccess' && <CreateGroupAccess />}

        </Interface>
    );
};

export default Container;